import Vue from 'vue'

// LAYOUTS
import RootLayout from '@/app/shared/layouts/RootLayout.vue'
Vue.component('root-layout', RootLayout);

import BaseLayout from '@/app/shared/layouts/BaseLayout.vue'
Vue.component('base-layout', BaseLayout);

import SidebarLayout from '@/app/shared/layouts/SidebarLayout.vue'
Vue.component('sidebar-layout', SidebarLayout);

import MapLayout from '@/app/shared/layouts/MapLayout.vue'
Vue.component('map-layout', MapLayout);

// COMPONENTS
import Cookie from '@/app/shared/components/common/Cookie.vue'
Vue.component('comp-cookie', Cookie);

import Loading from './../elements/Loading.vue'
Vue.component('comp-loading', Loading);

import ElementMenuLeft from './../elements/MenuLeft.vue'
Vue.component('elements-menu-left', ElementMenuLeft);


//import ModalConfirmation from './../elements/ModalConfirmation.vue'
//Vue.component('modal-confirmation', ModalConfirmation);


// COMPONENTS FORM
Vue.component('Pagination', () => import(/* webpackChunkName: "form-elements" */ '@/components/form/Pagination.vue'));
Vue.component('MaterialInput', () => import(/* webpackChunkName: "form-elements" */ '@/components/form/MaterialInput.vue'));
Vue.component('MaterialTextarea', () => import(/* webpackChunkName: "form-elements" */ '@/components/form/MaterialTextarea.vue'));
Vue.component('MaterialPassword', () => import(/* webpackChunkName: "form-elements" */ '@/components/form/MaterialPassword.vue'));
Vue.component('MaterialSelect', () => import(/* webpackChunkName: "form-elements" */ '@/components/form/MaterialSelect.vue'));
Vue.component('MaterialSelect2', () => import(/* webpackChunkName: "form-elements" */ '@/components/form/MaterialSelect2.vue'));
Vue.component('MaterialAutocomplete', () => import(/* webpackChunkName: "form-elements" */ '@/components/form/MaterialAutocomplete.vue'));
Vue.component('MaterialDateRangePicker', () => import(/* webpackChunkName: "form-elements" */ '@/components/form/MaterialDateRangePicker.vue'));
Vue.component('MaterialTimePicker', () => import(/* webpackChunkName: "form-elements" */ '@/components/form/MaterialTimePicker.vue'));
Vue.component('SimpleInput', () => import(/* webpackChunkName: "form-elements" */ '@/components/form/SimpleInput.vue'));
Vue.component('SimpleGroupInput', () => import(/* webpackChunkName: "form-elements" */ '@/components/form/SimpleGroupInput.vue'));
Vue.component('SimpleSelect', () => import(/* webpackChunkName: "form-elements" */ '@/components/form/SimpleSelect.vue'));
Vue.component("MaterialCheckbox", () => import(/* webpackChunkName: "form-elements" */ "@/components/form/MaterialCheckbox.vue"));